// eslint-disable-next-line import/prefer-default-export
export const ASSET_FILE_MAX_SIZE = 100000000 // 100MB
